module.exports = __webpack_public_path__ + "static/profilepic-bbfed825a201e76a1b66d34e162b2c41.jpg";